module.exports = __webpack_public_path__ + "img/others-pg.5a5e3f38.svg";